export default __webpack_public_path__ + "static/media/Frame 10950_hover.9990b72d.svg";